module.exports = __webpack_public_path__ + "static/media/0-3788_simple-light-blue-background.b2af6147.jpg";